import { useState } from "react";
import * as queries from "../graphql/queries";
import { generateClient } from "aws-amplify/api";
import useS3 from "./useS3";
import { useUserData } from "./useUserData";

const client = generateClient();

export const useFetchFacereveal = () => {
  const { fetchUserInfo } = useUserData();
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const { getUrlImage } = useS3();

  const onFetch = async (
    id: string,
    image: string,
    setResult?: (result: any) => void,
  ) => {
    setDownloading(true);
    const date = new Date().toISOString();
    const allJobs = await client.graphql({
      query: queries.getFacerevealJob,
      authMode: "apiKey",
      variables: { id },
    });
    const result = allJobs.data?.getFacerevealJob?.result ?? "[]";
    const resultArray = JSON.parse(result);
    // setResult && setResult(resultArray);
    if (resultArray.error) {
      setError(resultArray.error);
      setDownloading(false);
      return;
    }

    if (!!resultArray) {
      const updatedResultArray = await Promise.all(
        resultArray.map(async (item: any) => {
          const uri = await getUrlImage(item.image_key);
          return { ...item, image_key: uri?.url.toString() };
        }),
      );
      // updatedResultArray.unshift({
      //   image_key: image,
      //   score: 100,
      //   url: "",
      //   date: date,
      // });

      setResult && setResult(updatedResultArray);
    }

    setDownloading(false);
    await fetchUserInfo();
  };

  return { onFetch, downloading, error };
};
